import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { useAccountReadContext, useAccountWriteContext } from '@context/AccountContextContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { Button } from '@ui/components/Button'

import { isDepositBeforeKYC, isDepositPlaced } from '@utils/AccountAccess/accountKYCStatuses'

import { isVerificationExpedited } from '@model/AccountDetailedDto'
import { isAccountActivatedStatus } from '@model/AccountDetailedStatus'

import { useDocumentVerificationPath } from '@hooks/useDocumentVerificationPath'
import { useLandingPage } from '@hooks/useLandingPage'
import { safeLocalStorage } from '@hooks/useStorage'

import {
  StatusTemplateBody,
  StatusTemplateButtons,
  StatusTemplateWrapper,
} from '@shared/templates/StatusTemplate/StatusTemplate'

import { SignupFormWrapper } from '../../Components/SignupFormWrapper'
import { SignupSections, SignupStep } from '../../Components/SignupStep'

export const ConfirmPage: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useAccountReadContext()
  const docVerificationPath = useDocumentVerificationPath()

  const navigate = useNavigate()

  const locale = useSessionLanguage()
  const { getLandingPage } = useLandingPage()

  const { refreshAccount } = useAccountWriteContext()

  useEffect(() => {
    return () => safeLocalStorage.removeItem('hasAdditionalId')
  }, [])

  const handleGoToDashboard = async () => {
    await refreshAccount(locale)

    if (
      !isDepositBeforeKYC(account) &&
      isVerificationExpedited(account) &&
      !isAccountActivatedStatus(account)
    ) {
      navigate(docVerificationPath)
      return
    }

    const shouldNavigateToTransactionHistory =
      isDepositBeforeKYC(account) && isDepositPlaced(account)

    const path = shouldNavigateToTransactionHistory
      ? '/dashboard/traders-room/transaction-history'
      : getLandingPage()

    navigate(path)
  }

  return (
    <SignupFormWrapper label={t('Sign up.Sign Up')}>
      <SignupStep section={SignupSections.ReviewConfirm} accountTypeId={account?.type?.id} />
      <StatusTemplateWrapper>
        <StatusTemplateBody
          title={t('Sign up.Thank you for Registering!')}
          text={[t('Sign up.Give us max 24 hours to verify your identity.')]}
          icon={'Success'}
        />
        <StatusTemplateButtons>
          <Button.Primary size='lg' onClick={handleGoToDashboard}>
            {t('Sign up.Go to Dashboard')}
          </Button.Primary>
        </StatusTemplateButtons>
      </StatusTemplateWrapper>
    </SignupFormWrapper>
  )
}
